/** Formateadores y etiquetas de presentación de Aliados (US-2.2, es-CO). */
import type { AllyDocumentType, PersonType } from '@goelectric/shared-types';

export const PERSON_TYPE_LABELS: Record<PersonType, string> = {
  JURIDICA: 'Persona jurídica',
  NATURAL: 'Persona natural',
};

export const DOCUMENT_TYPE_LABELS: Record<AllyDocumentType, string> = {
  NIT: 'NIT',
  CC: 'Cédula de ciudadanía',
  CE: 'Cédula de extranjería',
};

interface FiscalIdentity {
  documentType: AllyDocumentType;
  documentNumber: string;
  checkDigit?: number;
}

/**
 * Documento compuesto para presentación — **regla única del contrato `Ally`**:
 * `{documentNumber}-{checkDigit}` cuando el documento es NIT; sin DV (CC/CE) se
 * muestra solo el número. El compuesto es una convención de escritura, no un dato
 * almacenado. Ojo: `AllySummary` no expone `checkDigit`, así que el compuesto solo
 * está disponible en el detalle.
 */
export function formatAllyDocument(ally: FiscalIdentity): string {
  if (ally.documentType === 'NIT' && ally.checkDigit !== undefined && ally.checkDigit !== null) {
    return `${ally.documentNumber}-${ally.checkDigit}`;
  }
  return ally.documentNumber;
}

/** Nombre a mostrar: razón social (jurídica) o nombres + apellidos (natural). */
export function allyDisplayName(ally: {
  legalName?: string;
  firstName?: string;
  lastName?: string;
}): string {
  if (ally.legalName) {
    return ally.legalName;
  }
  const naturalName = [ally.firstName, ally.lastName].filter(Boolean).join(' ').trim();
  return naturalName || '—';
}

/** Fecha/hora corta local (es-CO) para el detalle. */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) {
    return '—';
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString('es-CO', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
